/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

import pluginFactory from 'taoTests/runner/plugin';
import MenuPanelContent from './MenuPanelContent.svelte';

/**
 * This plugin provides the delt panel content
 */
export default pluginFactory({
    name: 'menuPanel',

    init() {
        //mandatory
    },

    /**
     * Renders to the menu panel
     */
    render() {
        const testRunner = this.getTestRunner();
        const areaBroker = testRunner.getAreaBroker();
        const options = testRunner.getOptions();
        const theme = testRunner.getTheme();
        const menuProperties = {
            exitUrl: options && options.exitUrl
        };
        if (theme && theme.menu) {
            if (Array.isArray(theme.menu.links)) {
                menuProperties.links = theme.menu.links;
            }
            if (theme.menu.footer) {
                menuProperties.footer = theme.menu.footer;
            }
        }

        //render the plugin component
        this.menuPanelContent = new MenuPanelContent({
            target: areaBroker.getPanelArea(),
            props: menuProperties
        });
    },

    /**
     * Destroys the plugin
     */
    destroy() {
        if (this.menuPanelContent) {
            this.menuPanelContent.$destroy();
        }
    }
});
